export interface Category {
  slug: string;
  name: string;
  description: string;
}

export const categories: Category[] = [
  {
    slug: 'mingxing',
    name: '明星黑料',
    description: '最新明星八卦、娱乐圈内幕曝光，第一时间掌握明星黑料动态',
  },
  {
    slug: 'wanghong',
    name: '网红黑料',
    description: '网红主播、短视频达人不为人知的另一面，真实爆料汇总',
  },
  {
    slug: 'dawei',
    name: '大V黑料',
    description: '微博大V、知乎大V、B站UP主等知名博主黑料合集',
  },
  {
    slug: 'zuixin',
    name: '最新爆料',
    description: '24小时最新最热的黑料资讯，实时更新，不错过任何瓜',
  },
  {
    slug: 'chiigua',
    name: '热点吃瓜',
    description: '当前最火的吃瓜话题，网友热议的黑料事件全收录',
  },
];